import { ButtonWhatsApp } from "./styles";
import whatsapp from "../../assets/whatsapp.svg";

export const WhatsApp = () => {
  window.onscroll = (): void => {
    const btn = document.getElementById("whatsapp-button") as HTMLElement;
    if (
      document.body.scrollTop > 100 ||
      document.documentElement.scrollTop > 100
    ) {
      btn.style.opacity = "1";
    } else {
      btn.style.opacity = "0";
    }
  };
  return (
    <ButtonWhatsApp>
      <a
        id="whatsapp-button"
        href="https://api.whatsapp.com/send?phone=5521966405629"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={whatsapp} alt="" />
      </a>
    </ButtonWhatsApp>
  );
};
